import { Checkbox, IconButton, TableCell } from "@material-ui/core";
import MuiTableRow from "@material-ui/core/TableRow";
import { StatusToUpdate } from "constants/status";
import { Hub } from "generated/graphql";
import { EditIcon } from "icons";
import React from "react";
import { CSSProperties } from "styled-components";
import { Action } from "ui/ActionGroup/actiongroup";
import clsx from "clsx";
import { MenuActions } from "./MenuActions";
import { useTableStyles } from "./styles";
import { Column } from "./Table";

const radioButtonStyle: CSSProperties = {
  float: "left",
};

export interface RowProps<RowData, RowDataKey extends keyof RowData> {
  columns: Array<Column<RowData>>;
  rowContent: RowData;
  rowsIdentifier: RowDataKey;
  onRowChecked?(data: RowData): void;
  onRowClick?(data: RowData): void;
  onRowMenuClick?(key: string, row: RowData): void;
  handleRowSelectClick(event: React.MouseEvent<unknown, MouseEvent>, id: string): void;
  rowsCount?: number;
  selectRowsCount?: number;
  refetchTableData?(): Promise<any>;
  hasSelection?: boolean;
  isRowSelected(rowIdentifier: any): boolean;
  isCurrentRow?(data: RowData): boolean;
  isShowMenu?: boolean;
  showMenu?: boolean;
  multipleActions?: Action[];
  rowColor?: string;
  onRowCheckedRow(event: React.MouseEvent<unknown, MouseEvent>, id: string): void;
  handleGetReceiverHub?(data: Hub, rowId: string): void;
  autoChecked?: boolean;
  hasRadioButton?: boolean;
  selectedRadionButton?: string;
  onRadioButtonSelected?(data: RowData): void;
  onRowEdit?(data: RowData): void;
  rowScanned?: string[];
}

export function FormattedTableCell<T>({ column, row }: { column: Column<T>; row: any }) {
  return <>{column.render ? column.render(row) : row[column.field]}</>;
}
export const TableRow = <RowData, RowDataKey extends keyof RowData>({
  rowContent,
  columns,
  rowsCount,
  selectRowsCount,
  rowsIdentifier,
  refetchTableData,
  hasSelection,
  onRowClick,
  isRowSelected,
  handleRowSelectClick,
  isCurrentRow,
  onRowMenuClick,
  isShowMenu,
  showMenu,
  multipleActions,
  rowColor,
  onRowChecked,
  autoChecked,
  hasRadioButton,
  selectedRadionButton,
  onRadioButtonSelected,
  onRowEdit,
  rowScanned,
}: RowProps<RowData, RowDataKey>) => {
  const rowId = rowContent[rowsIdentifier] as unknown as string;
  const isSelected = isRowSelected(rowId);
  const isCurrentRowSelected = isCurrentRow?.(rowContent);

  const classes = useTableStyles({ color: rowColor });

  const menuOptions = React.useMemo(() => {
    // eslint-disable-next-line dot-notation
    if (rowContent["parcel_status"]) {
      // eslint-disable-next-line dot-notation
      return StatusToUpdate.onprogress.includes(rowContent["parcel_status"]);
    }
    // eslint-disable-next-line dot-notation
    return StatusToUpdate.onprogress.includes(rowContent["order_status"]);
  }, [rowContent]);
  const handleClickRow = (event: any) => {
    onRowClick && onRowClick(rowContent);
    event.stopPropagation();
  };
  const handleChecbox = (event: any) => {
    handleRowSelectClick(event, rowId);
    onRowChecked && onRowChecked(rowContent);
    event.stopPropagation();
  };
  return (
    <>
      <MuiTableRow
        role="row"
        hover
        selected={autoChecked}
        onClick={handleClickRow}
        className={classes.tableCells}
        style={{
          backgroundColor: isCurrentRowSelected ? "#e4f4fb" : "inherit",
        }}
      >
        {hasSelection && (
          <TableCell align="right" padding="checkbox">
            <Checkbox color="primary" checked={isSelected || rowsCount === selectRowsCount} onClick={handleChecbox} />
          </TableCell>
        )}
        {hasRadioButton && (
          <TableCell align="right" padding="checkbox">
            <input
              type="radio"
              style={radioButtonStyle}
              id={rowId}
              name="fav_language"
              disabled={!rowScanned?.includes(rowId) && selectedRadionButton !== (rowContent as any)?._id}
              onChange={() => onRadioButtonSelected(rowContent)}
              checked={selectedRadionButton ? selectedRadionButton === (rowContent as any)?._id : null}
            />
          </TableCell>
        )}
        {columns?.map((column) => (
          <TableCell key={column.field} align="left">
            <FormattedTableCell column={column} row={rowContent} />
          </TableCell>
        ))}
        {isShowMenu &&
          (multipleActions &&
          // eslint-disable-next-line dot-notation
          !menuOptions ? (
            <TableCell />
          ) : (
            <TableCell align="left">
              <MenuActions actions={multipleActions} row={rowContent} onRowMenuClick={onRowMenuClick} />
            </TableCell>
          ))}
        {showMenu && multipleActions && (
          // eslint-disable-next-line dot-notation
          <TableCell align="left">
            <MenuActions
              actions={multipleActions}
              row={rowContent}
              onRowMenuClick={onRowMenuClick}
              menuButton={showMenu}
            />
          </TableCell>
        )}
        <TableCell align="right">
          {onRowEdit && (
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                onRowEdit(rowContent);
              }}
            >
              <EditIcon width={20} />
            </IconButton>
          )}
        </TableCell>
      </MuiTableRow>
    </>
  );
};
